import { render, staticRenderFns } from "./PlanningTrainingsPage.vue?vue&type=template&id=57e51cd8&"
import script from "./PlanningTrainingsPage.vue?vue&type=script&lang=js&"
export * from "./PlanningTrainingsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports